import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
    BuildingOffice2Icon,
    CalendarDaysIcon,
    HashtagIcon,
    ArrowRightIcon,
    ArrowLeftOnRectangleIcon,
} from '@heroicons/react/24/outline'
import Header from '../../../Components/Header'
import { formatDate } from '../../../Common'
import { AuthContext } from '../../../Context'
import { AuthContextApi } from '../../../Context/api'

const InvestimentosInvestidor = () => {
    const navigate = useNavigate()
    const { states, setters } = useContext(AuthContext)
    const { logoutInvestidor, getEmpreendimentosInvestidor } = useContext(AuthContextApi)

    useEffect(() => {
        getEmpreendimentosInvestidor()
        return () => setters.setDataEmpreendimentos([])
    }, [])

    const handleLogout = async () => {
        await logoutInvestidor()
        navigate('/investidor/login')
    }

    const empreendimentos = states.dataEmpreendimentos ?? []

    return (
        <>
            <Header
                title="Meus Investimentos"
                description="Acompanhe apenas os investimentos vinculados ao seu perfil"
                icon={BuildingOffice2Icon}
                hasAction={false}
                hasReturn={false}
            />

            <div className="px-6 pt-5 pb-6">
                <div className="flex justify-end mb-4">
                    <button
                        onClick={handleLogout}
                        className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors text-sm font-semibold"
                    >
                        <ArrowLeftOnRectangleIcon className="w-4 h-4" />
                        Sair
                    </button>
                </div>

                {states.isLoading ? (
                    <div className="flex flex-col items-center justify-center py-20">
                        <span className="h-8 w-8 rounded-full border-2 border-gray-200 border-t-brand-yellow animate-spin mb-3" />
                        <p className="text-sm text-gray-400">Carregando empreendimentos...</p>
                    </div>
                ) : empreendimentos.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-20 text-center">
                        <div className="w-14 h-14 rounded-2xl bg-gray-900 flex items-center justify-center mb-4">
                            <BuildingOffice2Icon className="w-7 h-7 text-brand-yellow" />
                        </div>
                        <h3 className="text-base font-semibold text-gray-900 mb-1">Nenhum investimento encontrado</h3>
                        <p className="text-sm text-gray-400">Você ainda não possui empreendimentos vinculados.</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        {empreendimentos.map((item) => (
                            <div key={item.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
                                <div className="flex items-start justify-between gap-4">
                                    <div className="min-w-0">
                                        <div className="inline-flex items-center gap-1 px-2 py-1 rounded-lg bg-gray-900 text-brand-yellow text-xs font-semibold">
                                            <HashtagIcon className="w-3 h-3" />
                                            Código {item.codigo_empreendimento}
                                        </div>
                                        <h3 className="text-base font-bold text-gray-900 mt-3 truncate">
                                            {item.nome_empreendimento}
                                        </h3>
                                        <div className="mt-3 space-y-1">
                                            <p className="text-xs text-gray-500 flex items-center gap-1">
                                                <CalendarDaysIcon className="w-3.5 h-3.5" />
                                                Criação: {formatDate(item.data_criacao)}
                                            </p>
                                            <p className="text-xs text-gray-500 flex items-center gap-1">
                                                <CalendarDaysIcon className="w-3.5 h-3.5" />
                                                Atualização: {formatDate(item.data_atualizacao)}
                                            </p>
                                        </div>
                                    </div>

                                    <button
                                        onClick={() => navigate(`/investidor/investimentos/investimento/${item.id}`)}
                                        className="inline-flex items-center gap-1 px-3 py-2 rounded-xl bg-brand-yellow text-gray-900 text-xs font-bold hover:bg-brand-yellow-dark transition-colors flex-shrink-0"
                                    >
                                        Acessar
                                        <ArrowRightIcon className="w-3.5 h-3.5" />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    )
}

export default InvestimentosInvestidor
